module.exports = __webpack_public_path__ + "img/TedXiaoPhD.5ab8c0c8.png";